export default "__VITE_ASSET__aa76c975__"